import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * Public route component
 * Redirects to dashboard if user is already authenticated
 */
const PublicRoute = ({ component: Component }) => {
    const { isAuthenticated } = useSelector((state) => state.auth);

    console.log('PublicRoute - isAuthenticated:', isAuthenticated);

    // If user is authenticated, redirect to dashboard
    if (isAuthenticated) {
        console.log('PublicRoute - Redirecting to dashboard');
        return <Navigate to="/dashboard" replace />;
    }

    // Otherwise, render the component
    console.log('PublicRoute - Rendering component');
    return <Component />;
};

export default PublicRoute;
